import {z} from 'zod'

import {apiFetch} from '../api/fetch'
import {
    type CreateInvoiceInput,
    createInvoiceRequestSchema,
    type Invoice,
    type InvoiceListItem,
    invoiceListItemSchema,
    invoiceSchema,
    type RecordExternalInvoiceInput,
    recordExternalInvoiceRequestSchema,
} from './schemas'

export async function listInvoices(): Promise<InvoiceListItem[]> {
    const raw = await apiFetch<unknown>('/invoices')
    return z.array(invoiceListItemSchema).parse(raw)
}

export async function getInvoice(id: string): Promise<Invoice> {
    const raw = await apiFetch<unknown>(`/invoices/${id}`)
    return invoiceSchema.parse(raw)
}

export async function createInvoice(input: CreateInvoiceInput): Promise<Invoice> {
    const body = createInvoiceRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/invoices', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return invoiceSchema.parse(raw)
}

export async function recordExternalInvoice(
    invoiceId: string,
    input: RecordExternalInvoiceInput,
): Promise<Invoice> {
    const body = recordExternalInvoiceRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/invoices/${invoiceId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
    })
    return invoiceSchema.parse(raw)
}

export async function voidInvoice(invoiceId: string): Promise<Invoice> {
    const raw = await apiFetch<unknown>(`/invoices/${invoiceId}/void`, {
        method: 'POST',
    })
    return invoiceSchema.parse(raw)
}
